<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M0 0h20v20H0V0z" />
    <path
      d="M10 20c5.523 0 10-4.478 10-10S15.523 0 10 0 0 4.478 0 10s4.478 10 10 10zm.833-5H9.168V8.332h1.665V15zM10 4.793a1.041 1.041 0 11-1.042 1.04c0-.576.467-1.04 1.042-1.04z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
